import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import FormLabel from "@material-ui/core/FormLabel";

import Button from "common/components/CustomButtons/Button.jsx";
import Phone from "@material-ui/icons/Phone";
import EasyOpenInput from "common/components/EasyForm/EasyOpenInput";
import EasySwitch from "common/components/EasyForm/EasySwitch";

import loadForm from "core-module/hoc/loadForm";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center",
    fontSize: "15px"
  },
  containerLine: {},
  editButton: {
    textAlign: "right",
    margin: "10px"
  }
};

const VoicemailSettingsWizard = props => {
  const { classes } = props;
  return (
    <GridContainer justify="center">
      <GridItem xs={12} lg={6}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Phone />
            </CardIcon>
            <h4 className={classes.cardIconTitle}> Voicemail Settings</h4>
          </CardHeader>
          <CardBody>
            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  Voicemail Status
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasySwitch
                  propName="vm_enable"
                  connectForm={props.connectForm}
                />
              </GridItem>
            </GridContainer>
            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  Voicemail Password
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasyOpenInput
                  propName="vm_password"
                  connectForm={props.connectForm}
                />
              </GridItem>
            </GridContainer>

            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  Send e-mail notification
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasySwitch
                  propName="vm_sendemail"
                  connectForm={props.connectForm}
                />
              </GridItem>
            </GridContainer>

            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  Notification E-mail Address
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasyOpenInput
                  propName="vm_email"
                  connectForm={props.connectForm}
                />
              </GridItem>
            </GridContainer>

            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  Attach soundfile to e-mail
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasySwitch
                  propName="vm_emailattachfile"
                  connectForm={props.connectForm}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={6}>
                <Button
                  fullWidth
                  onClick={() => {
                    props.connectForm.cancel();
                    props.closeWizard();
                  }}
                  color="primaryRed"
                >
                  Cancel
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6}>
                <Button
                  fullWidth
                  onClick={() => {
                    props.connectForm.post(props.closeWizard);
                    // props.connectForm.post().then(() => props.closeWizard());
                  }}
                  color="primaryLightBlue"
                >
                  Submit
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(
  loadForm(
    "user.session/billingpackage.props/voipfeatures.props",
    VoicemailSettingsWizard
  )
);
